import React from 'react';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    width: 100%;
    padding: 0 var(--grid-padding, 10px);
`;

const Iframe = styled('iframe')`
    aspect-ratio: 16 / 9;
    width: 100%;
    border: none;
`;

const Configurator: React.FC = () => (
    <Wrapper>
        <Iframe
            title="Configurator"
            frameBorder="0"
            allowFullScreen
            allow="clipboard-write; fullscreen"
            loading="lazy"
            src="https://planner.fogia.com/?iframe=1"
            style={{ aspectRatio: '16 / 9', width: '100%' }}
        />
    </Wrapper>
);

export default Configurator;
